export default __webpack_public_path__ + "static/media/TL11.b06922d1.mp3";